import { render, staticRenderFns } from "./videoUploadHandler.vue?vue&type=template&id=1b6099d4&scoped=true"
import script from "./videoUploadHandler.vue?vue&type=script&lang=js"
export * from "./videoUploadHandler.vue?vue&type=script&lang=js"
import style0 from "./videoUploadHandler.vue?vue&type=style&index=0&id=1b6099d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6099d4",
  null
  
)

export default component.exports